import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from './plugins/vuetify';
import axios from 'axios';
import VueAxios from 'vue-axios';
//import Datepicker from '@vuepic/vue-datepicker';
//import '@vuepic/vue-datepicker/dist/main.css'

import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import BounceLoader from 'vue-spinner/src/BounceLoader.vue'

import AuthSvc from './service/AuthSvc.js';
import CommandSvc from './service/CommandSvc.js';

Vue.use(VueAxios, axios);
Vue.config.productionTip = false;

Vue.prototype.$AuthSvc = new AuthSvc(axios);
Vue.prototype.$CommandSvc = new CommandSvc(axios);
//Vue.prototype.$Datepicker = new Datepicker();

export default {
  data () {
    return {
      color: '#cc181e',
      color1: '#5bc0de',
      size: '45px',
      margin: '2px',
      radius: '2px'
    }
  },
  components: {
    PulseLoader,
    RingLoader,
    BounceLoader
  }
}

new Vue({
  router,
  vuetify,
  render: h => h(App),
}).$mount("#app");


